import { useTranslation } from "react-i18next";

const useLocale = () => {
  const { i18n } = useTranslation();
  return i18n.language;
};

export default useLocale;
